<script lang="ts">
	import type { Contact } from "../../../core/schema/Contact.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";

	export let contact: Contact;

	export let index: string | undefined = undefined;
	export let indexClass: string | undefined = undefined;

	const { TENANT_LOCALE } = getGlobalSettings();

	/* eslint-disable prefer-named-capture-group */
</script>

<div class="flex w-[16rem] flex-col">
	{#if index}
		<div class="flex justify-between">
			<p class="{indexClass} font-quicksand text-[4.375rem]">{index}</p>

			<DynamicPicture image={contact.photo} bucket="storage" alt={contact.fullName} width={168} height={252} />
		</div>
	{:else}
		<DynamicPicture
			image={contact.photo}
			bucket="storage"
			alt={contact.fullName}
			width={168}
			height={252}
			class="self-end"
		/>
	{/if}
	<div class="border-gray flex flex-col gap-2 border px-6 py-5">
		<p class="text-bito-black text-[1.5rem] font-extrabold">{nbspify(contact.fullName)}</p>
		<p class="text-bito-black text-xs">{nbspify(contact.position[TENANT_LOCALE])}</p>
		<p class="text-primary flex flex-col text-xs font-extrabold">
			<a href="tel:00420{contact.phoneNumber.replaceAll(' ', '')}">
				{nbspify(`+420 ${contact.phoneNumber.replace(/(\d{3})\s*(\d{3})\s*(\d{3})/u, "$1 $2 $3")}`)}
			</a>
			<a href="mailto:{contact.email}">
				{nbspify(contact.email)}
			</a>
		</p>
	</div>
</div>
